<template>
	<div id="">
		<div class="sku-box store-content ">
			<Slide></Slide>
			<!--公司产品-->
			<!--<div class="gray-box">
					<header class="title-header">
						<h5 class="title">公司产品</h5>
					</header>
					<div class="item-box">						
						<shopItem v-for="(item,index) in productsData" :key="index" :itemProduct='item' ></shopItem>						
					</div>
				</div>-->
		</div>

		<!--<div id="right">
			<div id="qq">
				<a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=615749774&site=qq&menu=yes">
					<div class="qq-Picture">
						<img src="@/assets/img/icon01.png" />
					</div>
					<div>技术咨询</div>
				</a>
			</div>
		</div>-->
	</div>
</template>

<script>
	import Slide from '@/components/slide'
	import productsData from '@/lib/productsData.js';
	import shopItem from '@/components/shop-item'

	export default {
		components: {
			Slide,
			shopItem
		},
		created() {

		},
		data() {
			return {
				productsData,

			};
		},
		methods: {

		}
	}
</script>
<!--<script src="..assets/js/jquery-2.1.4.js" type="text/javascript" charset="utf-8"></script>-->

<style>
	/* 浮层 */
	
	/*#right {
		float: right;
		position: fixed;
		right: 20px;
		bottom: 100px;
		z-index: 99999999;
	}
	
	#qq {
		 line-height: 80px; 
		width: 70px;
		height: 80px;
		background-color: white;
		border-radius: 10px;
		box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.3);
	}
	
	a {
		text-decoration: none;
		list-style: none;
		color: #000;
	}
	
	.qq-Picture img {
		width: 50px;
		height: 50px;
	}*/
</style>


// WEBPACK FOOTER //
// src/views/home.vue